import { useState } from 'react';

export function useExport(defaultPageSize = 'a4', defaultColumns = []) {
  const [selectedColumns, setSelectedColumns] = useState(defaultColumns);
  const [pdfPageSize, setPdfPageSize] = useState(defaultPageSize);

  const toggleColumn = (id) => {
    setSelectedColumns(prev =>
      prev.includes(id) ? prev.filter(c => c !== id) : [...prev, id]
    );
  };

  const selectAll = (columns) => {
    setSelectedColumns(columns.map(c => c.id || c.key));
  };

  const clearAll = () => setSelectedColumns([]);

  return {
    selectedColumns,
    setSelectedColumns,
    pdfPageSize,
    setPdfPageSize,
    toggleColumn,
    selectAll,
    clearAll,
  };
}
